(() => {
  if (window.__uqOriginalSearch) return;
  window.__uqOriginalSearch = true;
  const vendorScope = '(vendor:Contrado OR vendor:UNIKCOSA)';
  const states = new WeakMap();
  function searchUrl(form, value) {
    const term = value.replace(/[()]/g, ' ').trim().slice(0, 200);
    const url = new URL(form.action, window.location.origin);
    new FormData(form).forEach((v, k) => url.searchParams.set(k, String(v)));
    url.searchParams.set('q', term ? '(' + term + ') AND ' + vendorScope : vendorScope);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-uq-search-form]')) return;
    event.preventDefault();
    window.location.assign(searchUrl(form, form.querySelector('[data-uq-query]')?.value || '').href);
  });
  document.addEventListener('input', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-uq-query]')) return;
    const form = input.closest('[data-uq-live-search]');
    if (!form) return;
    const root = form.closest('dialog');
    const output = root?.querySelector('[data-uq-search-results]');
    const status = root?.querySelector('[data-uq-search-status]');
    if (!output || !status) return;
    let state = states.get(form);
    if (!state) { state = { version: 0, initial: output.innerHTML, timer: null, controller: null }; states.set(form, state); }
    clearTimeout(state.timer);
    state.controller?.abort();
    const version = ++state.version;
    const term = input.value.trim();
    output.removeAttribute('aria-busy');
    if (term.length < 2) {
      output.innerHTML = state.initial;
      status.textContent = term.length ? 'Type at least two characters to search.' : 'Search our original designs.';
      return;
    }
    state.timer = setTimeout(async () => {
      state.controller = new AbortController();
      output.setAttribute('aria-busy', 'true');
      status.textContent = 'Searching original designs…';
      try {
        const url = searchUrl(form, term);
        url.searchParams.set('section_id', 'unikcosa-original-suggest');
        const response = await fetch(url.href, { signal: state.controller.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Search unavailable');
        const documentResult = new DOMParser().parseFromString(await response.text(), 'text/html');
        const result = documentResult.querySelector('[data-uq-suggestions]');
        if (!result) throw new Error('Missing search section');
        if (state.version !== version) return;
        output.innerHTML = result.innerHTML;
        const count = Number(result.dataset.matchCount || 0);
        status.textContent = count ? 'Showing ' + count + ' original designs. Press Search for all results.' : 'No matching original designs. Try another colour or silhouette.';
      } catch (error) {
        if (error.name !== 'AbortError' && state.version === version) {
          output.replaceChildren();
          status.textContent = 'Press Search to view results.';
        }
      } finally { if (state.version === version) output.removeAttribute('aria-busy'); }
    }, 260);
  });
})();